import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/e86127b0d6548681f6482a93367df4ac.jpg"
            alt="اتصل بنا"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        </div>
        
        <div className="container mx-auto px-6 lg:px-20 relative z-10 text-center">
          <h1 className="text-white font-almarai font-black text-5xl lg:text-7xl mb-6">
            <span className="text-gold">تواصل</span> معنا
          </h1>
          <div className="w-24 h-1.5 bg-gold mx-auto mb-6"></div>
          <p className="text-white/90 font-cairo text-xl max-w-3xl mx-auto">
            نحن هنا لخدمتك على مدار الساعة
          </p>
        </div>
      </section>

      {/* Contact Info & Form Section */}
      <section className="py-24 bg-gradient-to-b from-white to-luxury-cream">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Information */}
            <div className="text-right">
              <div className="inline-flex items-center gap-2 bg-gold/10 px-4 py-2 rounded-full mb-6">
                <i className="ri-customer-service-2-line text-gold text-sm"></i>
                <span className="text-gold font-cairo font-bold text-sm">خدمة العملاء</span>
              </div>
              
              <h2 className="text-luxury-black font-almarai font-black text-4xl lg:text-5xl mb-6">
                نسعد بخدمتك
              </h2>
              
              <div className="w-20 h-1 bg-gold mb-8"></div>
              
              <p className="text-luxury-gray font-cairo text-lg leading-relaxed mb-12">
                فريقنا المتخصص جاهز للإجابة على جميع استفساراتك ومساعدتك في حجز رحلتك القادمة. تواصل معنا بالطريقة التي تناسبك.
              </p>

              {/* Contact Cards */}
              <div className="space-y-6">
                {/* Phone */}
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="flex items-start gap-4 text-right">
                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-gold/20 rounded-xl group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-phone-line text-gold text-2xl"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-luxury-black font-cairo font-bold text-xl mb-2">اتصل بنا</h4>
                      <a href="tel:+966XXXXXXXXX" className="text-luxury-gray font-cairo text-lg hover:text-gold transition-colors cursor-pointer">
                        +966 XX XXX XXXX
                      </a>
                      <p className="text-luxury-gray/70 font-cairo text-sm mt-1">متاح 24/7</p>
                    </div>
                  </div>
                </div>

                {/* WhatsApp */}
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="flex items-start gap-4 text-right">
                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-green-500/20 rounded-xl group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-whatsapp-line text-green-500 text-2xl"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-luxury-black font-cairo font-bold text-xl mb-2">واتساب</h4>
                      <a href="https://wa.me/966XXXXXXXXX" target="_blank" rel="noopener noreferrer" className="text-luxury-gray font-cairo text-lg hover:text-green-500 transition-colors cursor-pointer">
                        +966 XX XXX XXXX
                      </a>
                      <p className="text-luxury-gray/70 font-cairo text-sm mt-1">رد فوري</p>
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="flex items-start gap-4 text-right">
                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-gold/20 rounded-xl group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-mail-line text-gold text-2xl"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-luxury-black font-cairo font-bold text-xl mb-2">البريد الإلكتروني</h4>
                      <a href="mailto:info@fakhamalrafaha.com" className="text-luxury-gray font-cairo text-lg hover:text-gold transition-colors cursor-pointer">
                        info@fakhamalrafaha.com
                      </a>
                      <p className="text-luxury-gray/70 font-cairo text-sm mt-1">نرد خلال 24 ساعة</p>
                    </div>
                  </div>
                </div>

                {/* Location */}
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group">
                  <div className="flex items-start gap-4 text-right">
                    <div className="flex-shrink-0 w-14 h-14 flex items-center justify-center bg-gold/20 rounded-xl group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-map-pin-line text-gold text-2xl"></i>
                    </div>
                    <div className="flex-1">
                      <h4 className="text-luxury-black font-cairo font-bold text-xl mb-2">موقعنا</h4>
                      <p className="text-luxury-gray font-cairo text-lg">
                        جدة، المملكة العربية السعودية
                      </p>
                      <p className="text-luxury-gray/70 font-cairo text-sm mt-1">بالقرب من المطار</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div className="mt-12">
                <h4 className="text-luxury-black font-cairo font-bold text-xl mb-4 text-right">تابعنا على</h4>
                <div className="flex gap-4 justify-end">
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 flex items-center justify-center bg-luxury-black hover:bg-gold rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
                  >
                    <i className="ri-twitter-x-line text-white text-xl"></i>
                  </a>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 flex items-center justify-center bg-luxury-black hover:bg-gold rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
                  >
                    <i className="ri-instagram-line text-white text-xl"></i>
                  </a>
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 flex items-center justify-center bg-luxury-black hover:bg-gold rounded-full transition-all duration-300 hover:scale-110 cursor-pointer"
                  >
                    <i className="ri-facebook-fill text-white text-xl"></i>
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <div className="bg-white rounded-3xl shadow-2xl p-8 lg:p-12">
                <h3 className="text-luxury-black font-cairo font-bold text-2xl mb-2 text-right">
                  أرسل لنا رسالة
                </h3>
                <p className="text-luxury-gray font-cairo text-sm mb-8 text-right">
                  املأ النموذج وسنتواصل معك في أقرب وقت
                </p>

                <form className="space-y-6">
                  <div>
                    <label className="block text-luxury-black font-cairo font-semibold mb-2 text-right">
                      الاسم الكامل <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      className="w-full px-4 py-3 border-2 border-luxury-gray/20 rounded-xl focus:border-gold focus:outline-none transition-colors font-cairo text-right"
                      placeholder="أدخل اسمك"
                    />
                  </div>

                  <div>
                    <label className="block text-luxury-black font-cairo font-semibold mb-2 text-right">
                      البريد الإلكتروني <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      required
                      className="w-full px-4 py-3 border-2 border-luxury-gray/20 rounded-xl focus:border-gold focus:outline-none transition-colors font-cairo text-right"
                      placeholder="example@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-luxury-black font-cairo font-semibold mb-2 text-right">
                      رقم الجوال <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      required
                      className="w-full px-4 py-3 border-2 border-luxury-gray/20 rounded-xl focus:border-gold focus:outline-none transition-colors font-cairo text-right"
                      placeholder="05XXXXXXXX"
                    />
                  </div>

                  <div>
                    <label className="block text-luxury-black font-cairo font-semibold mb-2 text-right">
                      الموضوع <span className="text-red-500">*</span>
                    </label>
                    <select
                      required
                      className="w-full px-4 py-3 border-2 border-luxury-gray/20 rounded-xl focus:border-gold focus:outline-none transition-colors font-cairo text-right cursor-pointer"
                    >
                      <option value="">اختر الموضوع</option>
                      <option value="booking">استفسار عن حجز</option>
                      <option value="service">استفسار عن الخدمات</option>
                      <option value="complaint">شكوى</option>
                      <option value="suggestion">اقتراح</option>
                      <option value="other">أخرى</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-luxury-black font-cairo font-semibold mb-2 text-right">
                      الرسالة <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      required
                      rows={5}
                      maxLength={500}
                      className="w-full px-4 py-3 border-2 border-luxury-gray/20 rounded-xl focus:border-gold focus:outline-none transition-colors font-cairo text-right resize-none"
                      placeholder="اكتب رسالتك هنا (حتى 500 حرف)"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-gradient-to-l from-gold to-gold-dark text-luxury-black font-cairo font-bold text-lg px-8 py-4 rounded-full hover:shadow-xl transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
                  >
                    إرسال
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-24 bg-luxury-cream">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="text-center mb-12">
            <h2 className="text-luxury-black font-almarai font-black text-4xl lg:text-5xl mb-4">
              موقعنا على <span className="text-gold">الخريطة</span>
            </h2>
            <div className="w-24 h-1.5 bg-gold mx-auto mb-6"></div>
            <p className="text-luxury-gray font-cairo text-lg">
              نخدم جميع مناطق جدة ومكة المكرمة والمدينة المنورة
            </p>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-2xl h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3710.4261555788895!2d39.17753931495395!3d21.543333885779!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15c3d01fb1137e59%3A0xe059579737b118db!2sJeddah%20Saudi%20Arabia!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="موقع فخامة الرفاهية للتوصيل"
            ></iframe>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 lg:px-20">
          <div className="text-center mb-16">
            <h2 className="text-luxury-black font-almarai font-black text-4xl lg:text-5xl mb-4">
              الأسئلة <span className="text-gold">الشائعة</span>
            </h2>
            <div className="w-24 h-1.5 bg-gold mx-auto mb-6"></div>
            <p className="text-luxury-gray font-cairo text-lg">
              إجابات على أكثر الأسئلة شيوعاً
            </p>
          </div>

          <div className="max-w-4xl mx-auto space-y-4">
            {[
              {
                question: 'كيف يمكنني حجز رحلة؟',
                answer: 'يمكنك الحجز بسهولة من خلال صفحة الحجز على موقعنا، أو التواصل معنا عبر الواتساب أو الهاتف. فريقنا متاح 24/7 لمساعدتك.'
              },
              {
                question: 'هل يمكنني إلغاء أو تعديل الحجز؟',
                answer: 'نعم، يمكنك إلغاء أو تعديل حجزك قبل 24 ساعة من موعد الرحلة دون أي رسوم إضافية. للتعديلات الطارئة، يرجى التواصل معنا مباشرة.'
              },
              {
                question: 'ما هي وسائل الدفع المتاحة؟',
                answer: 'نقبل الدفع نقداً، أو عن طريق التحويل البنكي. يمكنك الدفع للسائق مباشرة أو الدفع المسبق عند الحجز.'
              },
              {
                question: 'هل السائقون مرخصون ومؤمنون؟',
                answer: 'نعم، جميع سائقينا مرخصون ومدربون على أعلى مستوى، وجميع سياراتنا مؤمنة بالكامل لضمان سلامتك وراحتك.'
              },
              {
                question: 'هل تقدمون خدمة استقبال من المطار؟',
                answer: 'نعم، نوفر خدمة استقبال من جميع المطارات مع لوحة باسمك ومساعدة في حمل الأمتعة.'
              },
              {
                question: 'كم تستغرق الرحلة من المطار إلى مكة؟',
                answer: 'عادة تستغرق الرحلة من مطار جدة إلى مكة المكرمة حوالي 60-90 دقيقة حسب حركة المرور.'
              }
            ].map((faq, index) => (
              <details
                key={index}
                className="bg-luxury-cream rounded-2xl p-6 hover:shadow-lg transition-all duration-300 group"
              >
                <summary className="flex items-center justify-between cursor-pointer text-right">
                  <h4 className="text-luxury-black font-cairo font-bold text-lg flex-1">
                    {faq.question}
                  </h4>
                  <i className="ri-arrow-down-s-line text-gold text-2xl group-open:rotate-180 transition-transform duration-300"></i>
                </summary>
                <p className="text-luxury-gray font-cairo text-base mt-4 leading-relaxed text-right">
                  {faq.answer}
                </p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
